import React from "react";
import { Box } from "@mui/material";
import colors from "../../themes/colors";
import { dt } from "../../themes/redesignTokens";

const variantStyles = {
  contained: {
    color: dt.blue,
    background: colors.primary.lightBlue3,
    border: 'none'
  },
  outlined: {
    color: colors.icons.orange,
    background: "none",
    border: `1px solid ${colors.icons.orange}`
  }
} as const;

export type ChipVariant = 'contained' | 'outlined';

export type ChipVariantMap<T extends string | number> = {
  [K in T]: ChipVariant;
};

export type ChipLabelMap<T extends string | number> = {
  [K in T]: string;
};

export interface ValueChipProps<T extends string | number> {
  type: T;
  variantMap: ChipVariantMap<T>;
  labelMap: ChipLabelMap<T>;
  value?: string;
}

export const ValueChip = <T extends string | number>({
  type,
  variantMap,
  labelMap,
  value
}: ValueChipProps<T>) => {
  const variant = variantMap[type] || "outlined";
  const styles = variantStyles[variant];
  const displayValue = value || labelMap[type] || "";

  return (
    <Box
      className="text-14-medium"
      color={styles.color}
      border={styles.border}
      sx={{
        background: styles.background,
        borderRadius: "4px",
        width: "fit-content",
        padding: "4px 8px"
      }}
    >
      {displayValue}
    </Box>
  );
};